<div class="modal-header">
    <h4 class="modal-title fw-bold" id="splitLotHeader" jhiTranslate="inventoryManagerApp.lot.split.title">Split lot - New lot details</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row">
            <label for="stockIdPrefix" class="col-4 col-form-label">
                <span jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix">Stock ID Prefix</span>
                <i class="fa fa-info-circle col-1 help-icon ms-3" data-bs-toggle="tooltip" data-bs-placement="top" ngbTooltip="{{ 'inventoryManagerApp.lot.create.field.stock.id.title' | translate }}"></i>
            </label>
            <div class="col-4">
                <input type="text" jhi-stockIdPrefixValidator class="form-control" name="stockIdPrefix" id="stockIdPrefix" [(ngModel)]="model.stockIdPrefix" #stockIdPrefix="ngModel">
                <div class="invalid-feedback d-block" *ngIf="stockIdPrefix.invalid">
                    <small jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix.error"></small>
                </div>
            </div>
        </div>

        <div class="mb-3 row">
            <label class="col-4 col-form-label">
                <label class="form-check-label" jhiTranslate="inventoryManagerApp.lot.locationName">
                    Storage Location
                </label>
            </label>
            <div class="col-4">
                <jhi-storage-locations-select [(value)]="storageLocationId"></jhi-storage-locations-select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="lotNotes" class="col-4" jhiTranslate="inventoryManagerApp.lot.notes">Notes</label>
            <div class="col-4">
                <textarea class="form-control" rows="3" name="lotNotes" id="lotNotes" [(ngModel)]="lot.notes" jhi-forbiddenCharactersValidator #lotNotes="ngModel"></textarea>
            </div>
        </div>
        <div class="mb-3 row" style="margin-bottom: 0px;">
            <h4 class="modal-title fw-bold col-4" id="myDepositLabel" jhiTranslate="inventoryManagerApp.lot.create.field.deposit">Deposit</h4>
        </div>
        <div class="mb-3 row">
            <label class="col-4 col-form-label">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" (change)="checkInitialDeposit($event)" name="depositAvailable" id="depositAvailable" checked>
                    <label class="form-check-label" for="depositAvailable" jhiTranslate="inventoryManagerApp.lot.create.field.initial.deposit">
                        Initial deposit
                    </label>
                </div>
            </label>
        </div>
        <div class="border-top my-3">
        </div>
        <br>
        <div class="mb-3 row" [ngStyle]="{'margin-bottom': depositAmount.touched && depositAmount.invalid ? '0px':'16px'}">
            <label for="depositAmount" class="col-4 col-form-label" jhiTranslate="inventoryManagerApp.lot.create.field.amount">Amount</label>
            <div class="col-4">
                <input type="number" class="form-control" name="depositAmount" id="depositAmount"
                       [(ngModel)]="deposit.amount" jhi-customMinGreaterThanValidator min=0 #depositAmount="ngModel"
                       [ngClass]="{ 'is-invalid': f.submitted && depositAmount.invalid }"/>
                <div [hidden]="!(depositAmount.touched && depositAmount.invalid)">
                    <small class="invalid-feedback d-block" jhiTranslate="inventoryManagerApp.lot.create.field.amount.note">
                        Initial amount must be higher than zero
                    </small>
                </div>
            </div>

        </div>
        <div class="mb-3 row">
            <label for="depositNotes" class="col-4 col-form-label" jhiTranslate="inventoryManagerApp.lot.notes">Notes</label>
            <div class="col-4">
                <textarea class="form-control" rows="3" name="depositNotes" id="depositNotes" [(ngModel)]="deposit.notes" jhi-forbiddenCharactersValidator #depositNotes="ngModel"></textarea>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="save()" [disabled]="f.form.invalid || isInvalid()" class="btn btn-primary">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
    </button>
</div>
